// extracted by mini-css-extract-plugin
export default {"cls1":"usePaperAttachment-cls1_T_d","cls2":"usePaperAttachment-cls2_as5 usePaperAttachment-cls1_T_d"};